module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vbassets/_next/static/images/MaxiCosi-dd1dfe2330422a7e99f1d4c3483afda4.svg";